function LinkSuspicious() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>Link text contains extraneous text or may not make sense out of context.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Links, which are often read out of context, should clearly describe the destination or function of the link. Ambiguous text, text that does not make sense out of context, and extraneous text (such as "click here") can cause confusion and should be avoided.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Where appropriate, reword the link text so that it is more descriptive of its destination when read out of context. Remove any extraneous text (such as "click here").</p>
    </blockquote>
  )
}

export default LinkSuspicious